import { api } from './api';

export type KeigoRegister = 'first_formal' | 'follow_up' | 'introduced' | 'warm';

export interface SequenceStep {
  kind: 'email' | 'task' | 'wait';
  delayDays?: number;
  subject?: string;
  body?: string;
  taskTitle?: string;
}

export interface Sequence {
  id: string;
  workspaceId: string;
  name: string;
  language: 'ja' | 'en';
  keigoRegister: KeigoRegister | null;
  steps: SequenceStep[];
  active: boolean;
  ownerUserId: string | null;
  createdAt: string;
}

export interface SequenceEnrollment {
  id: string;
  sequenceId: string;
  contactId: string;
  status: 'active' | 'paused' | 'finished' | 'replied' | 'bounced';
  currentStep: number;
  nextActionAt: string | null;
  enrolledAt: string;
}

export const sequencesApi = {
  list: async (workspaceId: string): Promise<Sequence[]> => {
    const r = await api.get<Sequence[]>('/api/sequences', { params: { workspaceId } });
    return r.data;
  },
  get: async (id: string): Promise<Sequence> => {
    const r = await api.get<Sequence>(`/api/sequences/${id}`);
    return r.data;
  },
  create: async (input: { workspaceId: string; name: string; language: 'ja' | 'en'; keigoRegister?: KeigoRegister; steps?: SequenceStep[] }): Promise<Sequence> => {
    const r = await api.post<Sequence>('/api/sequences', input);
    return r.data;
  },
  update: async (id: string, patch: Partial<Sequence>): Promise<Sequence> => {
    const r = await api.patch<Sequence>(`/api/sequences/${id}`, patch);
    return r.data;
  },
  remove: async (id: string): Promise<void> => {
    await api.delete(`/api/sequences/${id}`);
  },
  enroll: async (sequenceId: string, contactId: string): Promise<SequenceEnrollment> => {
    const r = await api.post<SequenceEnrollment>(`/api/sequences/${sequenceId}/enrollments`, { contactId });
    return r.data;
  },
  enrollments: async (sequenceId: string): Promise<SequenceEnrollment[]> => {
    const r = await api.get<SequenceEnrollment[]>(`/api/sequences/${sequenceId}/enrollments`);
    return r.data;
  },
  unenroll: async (sequenceId: string, enrollmentId: string): Promise<void> => {
    await api.delete(`/api/sequences/${sequenceId}/enrollments/${enrollmentId}`);
  },
};
